module.exports = __webpack_public_path__ + "img/animal.3d9fb287.png";